import { FormGroup } from '@angular/forms';

/**
 * Resuelve la regla de 'notes' según la visibilidad activa.
 * El backend devuelve notes_public / notes_private en vez de notes.
 * Esta función inyecta una clave virtual 'notes' para retrocompatibilidad con los formularios.
 * Si el backend aún no migró (devuelve 'notes'), la mantiene tal cual.
 */
export function resolveNotesRule(
  rules: Record<string, string | null> | undefined | null,
  visibility: 'public' | 'private'
): Record<string, string | null> {
  if (!rules) return {};
  const resolved = { ...rules };
  if ('notes_public' in resolved || 'notes_private' in resolved) {
    const key = visibility === 'private' ? 'notes_private' : 'notes_public';
    resolved['notes'] = resolved[key] ?? null;
  }
  return resolved;
}

export function applyFieldRules(form: FormGroup, rules: Record<string, string> | undefined | null): void {
  for (const field in form.controls) {
    if (form.controls.hasOwnProperty(field)) {
      form.get(field)?.disable();
    }
  }
  if (rules) {
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        form.get(field)?.enable();
      }
    }
  }
}
